import zikzak from '../../assets/htbd-images/zikzak.png';
import Group from '../../assets/htbd-images/Group.png';
import circle from '../../assets/htbd-images/circle.png';
import add from '../../assets/htbd-images/add.png';
import BackroundGradient from './common/BackroundGradient.component';
import { SliderVideoPlayer } from './SliderVideoPlayer.component';
import logo from '../../assets/htbd-images/htbd-logo.png';


function Slider() {
  return (
    <section className="mb-5 text-center text-white position-relative">
      <BackroundGradient />
      <div className="mb-5 text-center text-white position-relative" style={{ height:"150px"}}>
        <span className="position-absolute top-0 translate-middle-x" style={{ zIndex: -1 }}>
          <img src={logo} alt="HTBD Logo" className="position-relative" />
        </span>
        <span className="position-absolute top-100 translate-middle-x" style={{ zIndex: -1, left:'20%' }}>
          <img src={zikzak} alt="zikzak" />
        </span>
        <span className="position-absolute top-50 translate-middle-x" style={{ zIndex: -1, right:'20%' }}>
          <img src={Group} alt="Group" />
        </span>
      </div>

      <div>
        <h1 className="display-1">
          How To Do <br />
          <strong style={{ color: "#7e56d8" }}>Business</strong> In Dubai
        </h1>
        <p className="fs-6 mb-0">Department - Seeding Brains RSDs</p>
        <p className="fs-6">Mr. Chinmay Chitransh - Program manager</p>
        <button type="button" className="btn btn-primary">
          Get Started
        </button>
      </div>
      <span className="position-absolute translate-middle-x" style={{ zIndex: -1, left:'20%', bottom:'-50' }}>
          <img src={circle} alt="circle" />
        </span>
        <span className="position-absolute translate-middle-x" style={{ zIndex: -1, right:'20%', bottom:'0' }}>
          <img src={add} alt="add" />
        </span>
      <div className="p-5" style={{ margin: '0 auto', width: 'fit-content'}}>
        <SliderVideoPlayer/>
      </div>
    </section>
  );
}

export default Slider;

